import { useEffect, useState } from 'react';
import { apiClient } from '@/lib/api';

/**
 * Decisión de Sebastián (3-nov): nadie se registra y entra solo a Prixia; se prueba con una
 * demo guiada por invitación (Mini Prixia). Sin un contacto inventado: cómo se pide la
 * invitación todavía no está decidido.
 */
export const MENSAJE_REGISTRO_CERRADO =
  'No hay registro libre: Prixia se prueba con una demo guiada, por invitación.';

/**
 * ¿Está abierto el alta pública de empresas? El servidor decide (`PUBLIC_SIGNUP_ENABLED`,
 * cerrado por defecto) y lo informa en `GET /api/auth/registro-publico`, que no pide sesión
 * y no dice nada más. Devuelve `null` mientras no responde; si falla, `false`: ante la
 * duda, no se ofrece registrarse.
 */
export function useRegistroPublico(): boolean | null {
  const [abierto, setAbierto] = useState<boolean | null>(null);

  useEffect(() => {
    let vivo = true;
    apiClient
      .get<{ habilitado?: boolean }>('/api/auth/registro-publico')
      .then((r) => {
        if (vivo) setAbierto(r?.habilitado === true);
      })
      .catch(() => {
        if (vivo) setAbierto(false);
      });
    return () => {
      vivo = false;
    };
  }, []);

  return abierto;
}
